import { useState } from "react"
import { toast } from 'react-hot-toast';
import ajaxParent from "../../../util/remote/ajaxParent";
import SystemModal from "../../Common/SystemModal";
import Loader from "../../Common/Loader";

const ConvertCreditToPM=(props)=>{

    const [loading, setLoading] = useState(false)
    const [amount,setAmount] =useState("")

    const data={
        credit_owner_user_id: props.userID,
        student_user_id: props.userID,
        amount: amount
    }

    const handleAdd = async(e) =>{
        e.preventDefault()
        if (amount > 0) {
            setLoading(true)
            const server_response = await ajaxParent.convertCreditToPM(data);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.h();
                props.i();
                props.j(props.pkPage);
                props.k(props.cpage);
            }
            else{
                toast.error(server_response.message); 
            }
        } else {
            toast.error("Please enter an amount!");
          } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleAdd}>Convert<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Convert Credit to Pocket Money"
            id="model-convert-credit-to-pm-std"
            size="md"
            footer={RenderFooter}
        >

        <div className="mb-4 col-12 form-group">
                <label htmlFor="">Amount <span style={{ color: "red" }}>*</span></label>
                <input type="text" value={amount} placeholder="Enter amount.." onChange={(e) => setAmount(e.target.value)} className="form-control" />
            </div>
       
        </SystemModal>
    )
}

export default ConvertCreditToPM
